import { render } from "./page.vue?vue&type=template&id=7fc7ce0d&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=7fc7ce0d&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc7ce0d"],['__file',"src/components/notepad/page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fc7ce0d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fc7ce0d', __exports__)) {
    api.reload('7fc7ce0d', __exports__)
  }
  
  module.hot.accept("./page.vue?vue&type=template&id=7fc7ce0d&scoped=true", () => {
    api.rerender('7fc7ce0d', render)
  })

}


export default __exports__